import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HeroImageComponent } from 'src/app/shared/hero-image/hero-image.component';
import { PdfViewerComponent } from 'src/app/shared/pdf-viewer/pdf-viewer.component';
import { PageLayoutBaseComponent } from '../page-layout-base.component';
import { PDFDocuments } from 'src/app/types/PDFDocuments';
import { AdobePdfService } from 'src/app/services/adobe-pdf.service';
import { AppService } from 'src/app/app.service';
import { CallOutBoxComponent } from '../../call-out-box/call-out-box.component';

@Component({
  selector: 'app-traffic',
  imports: [HeroImageComponent, PdfViewerComponent, CallOutBoxComponent],
  templateUrl: './traffic.component.html',
  styleUrl: './traffic.component.scss',
})
export class TrafficComponent
  extends PageLayoutBaseComponent
  implements OnInit, AfterViewInit
{
  pdfDocuments: PDFDocuments[] = [];

  constructor(
    protected override appService: AppService,
    private adobePdfService: AdobePdfService
  ) {
    super(appService);
    this.pdfDocuments = [
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Eastbound-Traffic-Operations-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/traffic/Eastbound-Traffic-Operations-09-23-2025.pdf',
        title: 'Eastbound - Existing & Future Traffic Conditions',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Westbound-Traffic-Operations-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/traffic/Westbound-Traffic-Operations-09-23-2025.pdf',
        title: 'Westbound - Existing & Future Traffic Conditions',
      },
    ];
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.adobePdfService.embedMultiplePdfs(this.pdfDocuments);
    }, 100);
  }
}
